import { useState } from 'react'; 
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Row, Col } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import { AgCharts } from "ag-charts-react";
import {
  LegendModule,
  ModuleRegistry,
  PieSeriesModule,
} from "ag-charts-community";

ModuleRegistry.registerModules([LegendModule, PieSeriesModule]);

const InfoModal = (props) => {
  const {show, setShow, title, body } = props;
  const [stop, setStop] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleClose = () => {
    setShow(false);
    if (dontShowAgain) setStop(true);
  };
  
  const handleToastClose = () => {
    setStop(false);
  };

  function getExpenseMonthlyData() {
    const data = [];
    props.expenseData.records.forEach(record => {
      data.push({ asset: record.description, amount: Number(record.monthlyAmount) });
    });
    return data;
  }

  function getExpenseWeeklyData() {
    const data = [];
    props.expenseData.records.forEach(record => {
      data.push({ asset: record.description, amount: Number(record.weeklyAmount) });
    });
    return data;
  }

  function getDebtData() {
    const data = [];
    props.debtData.records.forEach(record => {
      if (record.status !== 4) {
        if (props.debtData.manual) {
          data.push({ asset: record.company, amount: Number(props.yearCalc?record.monthlyIndividual:record.weeklyIndividual) });
        } else {
          data.push({ asset: record.company, amount: Number(props.yearCalc?record.monthlyOverall:record.weeklyOverall) });
        }
      }
    });
    return data;
  }

  const options = {
    data: getExpenseMonthlyData(),
    title: {
      text: "Expense Monthly Composition",
    },
    series: [
      {
        type: "pie",
        angleKey: "amount",
        legendItemKey: "asset",
      },
    ],
  };

  const options2 = {
    data: getExpenseWeeklyData(),
    title: {
      text: "Expense Weekly Composition",
    },
    series: [
      {
        type: "pie",
        angleKey: "amount",
        legendItemKey: "asset",
      },
    ],
  };

  const options3 = {
    data: getDebtData(),
    title: {
      text: "Debt Payments",
    },
    series: [
      {
        type: "pie",
        angleKey: "amount",
        legendItemKey: "asset",
      },
    ],
  };

  return (
    <>
      <Modal fullscreen={true} show={show && !stop} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {body}
          <Row>
            <Col xs={12} md={6} lg={4}>
              <AgCharts options={options} />
            </Col>
            <Col xs={12} md={6} lg={4}>
              <AgCharts options={options2} />
            </Col>
            <Col xs={12} md={6} lg={4}>
              <AgCharts options={options3} />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Form>
            <Form.Check
              type="checkbox"
              id="stop"
              label="Don't show this again"
              checked={dontShowAgain}
              onChange={(event) => setDontShowAgain(event.target.checked)}
            />
          </Form>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <ToastContainer
        className='notification'
        style={{ zIndex: 1 }}
      >
        <Toast onClose={() => setShow(false)} show={show && stop} delay={10000} autohide>
          <Toast.Header>
            <strong className="me-auto">Warning</strong>
            <small>Now</small>
          </Toast.Header>
          <Toast.Body>
            You have gone over budget.{' '}
            <Button variant="link" className="budget-help-link" onClick={handleToastClose}>
              View details
            </Button>
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
}

export default InfoModal;